module.exports = __webpack_public_path__ + "static/fossa-669046aefaebca57e388c1425dcccff8.svg";